module.exports = __webpack_public_path__ + "img/renz_img1.94d316d3.jpg";